export const WorkingDirectory = () => {
    return(
        <section>
        <h1>Working Directoriate</h1>
        </section>
    )
}